import ProjectAPIError from "@/api/error/ProjectAPIError";

export default class ProjectAPINotFoundError extends ProjectAPIError {
  get httpErrorMessage() {
    return "데이터가 없거나, 잘못된 URL로 호출하셨습니다";
  }
}
